export default __webpack_public_path__ + "static/media/settingIcon.86d7acf9.webp";